import { t } from "i18next";
import { useCallback, useState } from "react";

import Button from "~/components/buttons/Button";
import Hint from "~/components/Hint";
import SidebarBusyOverlay from "~/components/Sidebar/components/SidebarBusyOverlay";
import SidebarContent from "~/components/Sidebar/components/SidebarContent";
import SidebarErrorOverlay from "~/components/Sidebar/components/SidebarErrorOverlay";
import SidebarFooter from "~/components/Sidebar/components/SidebarFooter";
import SidebarHeader from "~/components/Sidebar/components/SidebarHeader";
import SidebarHeaderHeadline from "~/components/Sidebar/components/SidebarHeaderHeadline";
import { invoiceTypeId } from "~/modules/billing/api/invoiceType.ts";
import { deleteInvoice } from "~/modules/billing/api/processedInvoice/processedInvoiceApiDispatchers.ts";
import type { Invoice } from "~/modules/billing/api/processedInvoice/processedInvoiceTypes.ts";

type Props = {
	invoiceData: Invoice;
	onCancel: () => void;
	onSuccess: () => void;
};

const DeleteInvoiceForm = ({
	invoiceData,
	onCancel,
	onSuccess,
}: Props) => {
	const [showConfirmation, setShowConfirmation] = useState<boolean>(false);
	const [isBusy, setIsBusy] = useState(false);
	const [serverErrorMessage, setServerErrorMessage] = useState("");
	const isSelfBilledInvoice = invoiceData.invoiceTypeId === invoiceTypeId.SelfBilledInvoice;
	const onSubmit = useCallback(async () => {
		try {
			setIsBusy(true);
			await deleteInvoice(invoiceData.id);
			onSuccess();
		} catch (error) {
			console.log(error);
			setServerErrorMessage(t("form:unexpectedError"));
		}
	}, [invoiceData.id, onSuccess]);

	return (
		<div className="auto-grid-sidebar"
		>
			<SidebarHeader>
				<SidebarHeaderHeadline>Rechnung löschen</SidebarHeaderHeadline>
			</SidebarHeader>
			<SidebarContent>
				{isBusy && <SidebarBusyOverlay />}
				{!!serverErrorMessage &&
					<SidebarErrorOverlay title="Update failed">{serverErrorMessage}</SidebarErrorOverlay>}
				<Hint>
					<p>Eine Rechnung sollte nur in absoluten Ausnahmefällen gelöscht werden und keinesfalls, falls sie
						buchhalterisch bereits verarbeitet wurde oder ein Zahlungseingang erfolgt ist.</p>
					<br />
					{!isSelfBilledInvoice && <><p>Die Rechnungsnummer wird bei der Löschung wieder freigegeben und bei
						der Erstellung der nächsten
						Rechnung wiederverwendet.</p>
						<br /></>}
					<p>Alle Kommentare werden unwideruflich gelöscht!</p>

				</Hint>
				{showConfirmation &&
					<div className="mt-12">Bist Du sicher? Dieser Vorgang <strong>kann nicht rückgängig gemacht
						werden!</strong></div>}
			</SidebarContent>
			<SidebarFooter>
				{!showConfirmation && <Button onClick={() => setShowConfirmation(true)}>
					Rechnung löschen
				</Button>}
				{showConfirmation && <Button onClick={onSubmit}>
					Löschung bestätigen
				</Button>}
				<Button theme="white"
						onClick={onCancel}>
					Abbrechen
				</Button>
			</SidebarFooter>
		</div>);
};

export default DeleteInvoiceForm;
